export default {
  AddonAdda: 'ఒక అడ్డాను జోడించండి',
  notFindAdda: 'మీ అడ్డాను గుర్తించలేదా? దయచేసి మీ అడ్డాను జోడించండి',
  AddPhoto: 'ఫోటోను',
  earnMpoints: 'MPoints సంపాదిం చడానికి Adda లో Adda లేదా Checkin ని జోడించండి',
  postOffice: 'తపాలా కార్యాలయము',
  meter: 'మీటర్',
  VerifiedbyMall91: 'మాల్ 91 చే ధృవీకరించబడింది',
  Suggestandedit: 'సవరణను సూచించండి',
  GiveRating: 'రేటింగ్ ఇవ్వండి',
  Details: 'వివరాలు',
  MondaytoSaturday: 'సోమవారం నుండి శనివారం వరకు',
  checkIn: 'చెకిన్',
  CheckInAtAdda: 'అడ్డా వద్ద తనిఖీ చేయండి',
  ShareExperience:
    'మీ అనుభవాన్ని అడ్డాతో పంచుకోండి మరియు ఎంపాయింట్‌లను సంపాదించండి',
  AddaName: 'అడ్డా పేరు',
  AddAddanotfound: 'అడ్డా కనుగొనబడలేదు',
  Iamhere: 'నేను ఇక్కడ ఉన్నాను',
  Writesomethinghere: 'దయచేసి కొన్ని పదాలు రాయండి ..',
  plzCheckin: 'చెకిన్',
  PickyourCurrentLocation: 'మీ ప్రస్తుత స్థానాన్ని ఎంచుకోండి',
  TurnonLocation: 'స్థాన సేవలను ప్రారంభించండి',
  NoRecordsavailable: 'రికార్డులు అందుబాటులో లేవు',
  YoursPosts: 'మీ పోస్ట్లు',
  Makeasuggestion: 'ఒక సూచన చేయండి',
  Helpwithyoursuggestion: 'మీ విలువైన సూచనలతో మాకు సహాయం చేయండి',
  Addnewphoto: 'క్రొత్త ఫోటోను జోడించండి',
  warning:
    'సంబంధిత చిత్రాలు మరియు ఖచ్చితమైన సమాచారంతో మీ సలహాలకు మద్దతు ఇవ్వండి.',
  submit: 'సమర్పించండి',
  AllcheckIns: 'అన్ని చెకిన్లు',
  Nearbycheckins: 'సమీపంలోని చెకిన్లు',
  Home: 'హోమ్',
  AllAddas: 'అల్ అడ్డా',
  Notification: 'నోటిఫికేషన్',
  Profile: 'ప్రొఫైల్',
  TotalPost: 'మొత్తం పోస్ట్లు',
  TotalLikes: 'మొత్తం ఇష్టాలు',
  TotalComments: 'మొత్తం వ్యాఖ్యలు',
  Peoplehavecommented: 'ప్రజలు వ్యాఖ్యలు చేశారు',
  TypeAcomment: 'మీ కంటెంట్‌ను ఇక్కడ టైప్ చేయండి ..',
  GototheAdda: 'ఒక అడ్డాకు వెళ్ళండి',
  intro: 'ఒక Adda లో క్రొత్త Adda లేదా checkin ని జోడించి MPoints సంపాదించండి',
  Peoplehaveliked: 'ప్రజలు ఇష్టపడ్డారు',
  whichplaceyoustand: 'మీరు ఇప్పుడు ఏ అడ్డా వద్ద ఉన్నారు? చెకిన్!',
  Atwhichplace: 'మీరు ఇప్పుడు ఏ అడ్డా వద్ద ఉన్నారు? చెకిన్!',
  likes: 'ఇష్టాలు',
  share: 'వాటా',
  like: 'ఇలా',
  comments: 'వ్యాఖ్యలు',
  isAt: 'వద్ద ఉంది',
  FullAddress: 'పూర్తి చిరునామా',
  housenumber: 'ఇంటి సంఖ్య, వీధి లేదా గ్రామం',
  BusinessName: 'వ్యాపారం పేరు',
  Suchas: 'అగర్వాల్ మిఠాయి',
  AddNewCategory: 'క్రొత్త వర్గాన్ని జోడించండి',
  CREATE: 'సృష్టించదు',
  CANCEL: 'రద్దు చేయండి',
  city: 'నగరం',
  addCity: 'నగరాన్ని జోడించండి',
  Mobile: 'సంప్రదింపు సంఖ్య',
  enterMobileNumber: 'మొబైల్ నంబర్‌ను నమోదు చేయండి',
  pincode: 'పిన్',
  enterpincode: 'పిన్',
  state: 'రాష్ట్రం',
  AddState: 'రాష్ట్రాన్ని జోడించండి',
  wentWrong: 'ఎక్కడో తేడ జరిగింది!! దయచేసి మళ్ళీ ప్రయత్నించండి',
  category: 'వర్గం',
  Createcategory: 'వర్గాన్ని సృష్టించండి',
  UploadingImage: 'ఫోటో అప్‌లోడ్',
  AddAdda: 'అడ్డా జోడించండి',
  nofeed: 'సమాచారం లేదు',
  PleaseEnterdetails: 'దయచేసి వివరాలను నమోదు చేయండి',
  Pleaseentercomment: 'దయచేసి వ్యాఖ్యను నమోదు చేయండి',
  NoRecordsfound: 'ఎటువంటి పత్రాలు లభించలేదు',
  Citymustbevalid: 'నగరం చెల్లుబాటులో ఉండాలి',
  Pinmustbevalid: 'పిన్ చెల్లుబాటులో ఉండాలి',
  Mobilenomustbevalid: 'మొబైల్ నం. తప్పనిసరిగా చెల్లుబాటులో ఉండాలి',
  Businessnamemustbevalid: 'వ్యాపార పేరు చెల్లుబాటులో ఉండాలి',
  Photo: 'ఫోటో',
  Pleaseselectshopname: 'దయచేసి దుకాణం పేరును ఎంచుకోండి',
  Pleaseuploadphoto: 'దయచేసి ఫోటోను అప్‌లోడ్ చేయండి',
  isnecessary: 'అవసరము!',
  Categorycreated: 'వర్గం విజయవంతంగా సృష్టించబడింది',
  ThisCategoryAlreadyExists: 'ఈ వర్గం ఇప్పటికే ఉంది',
  Pleasecreatecategory: 'దయచేసి వర్గాన్ని సృష్టించండి'
}
